import { useState } from 'react';
import api from '@/lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Share2, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export const ShareCertificateDialog = ({ target, onClose }) => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);

  const send = async () => {
    if (!email.trim()) { toast.error('Enter a recipient email'); return; }
    setSending(true);
    try {
      await api.post(`/orders/items/${target.itemId}/certificate/share`, { to_email: email.trim() });
      toast.success(`Certificate shared with ${email.trim()}`);
      setEmail('');
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Failed to share certificate');
    } finally { setSending(false); }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => { if (!o) { setEmail(''); onClose(); } }}>
      <DialogContent className="max-w-sm" data-testid="share-certificate-dialog">
        <DialogHeader>
          <DialogTitle className="text-base flex items-center gap-2"><Share2 className="h-4 w-4" style={{ color: '#0E6B5D' }} /> Share Certificate</DialogTitle>
          <DialogDescription className="text-xs">
            Send certificate <span className="font-mono uppercase">{target?.certCode}</span>{target?.itemTitle ? ` for ${target.itemTitle}` : ''} by email. The recipient gets a link to the certificate viewer only.
          </DialogDescription>
        </DialogHeader>
        <Input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="recipient@email.com"
          className="h-9 text-sm" data-testid="share-certificate-email"
          onKeyDown={e => { if (e.key === 'Enter') send(); }} />
        <Button onClick={send} disabled={sending} className="w-full gap-1.5 text-xs" data-testid="share-certificate-send">
          {sending ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Share2 className="h-3.5 w-3.5" />} Send
        </Button>
      </DialogContent>
    </Dialog>
  );
};
